import * as Icons from "lucide-react";
import type { LucideIcon } from "lucide-react";

function toPascalCase(kebabCase: string): string {
  return kebabCase
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
}

export function getIcon(name: string): LucideIcon {
  const key = toPascalCase(name) as keyof typeof Icons;
  const icon = Icons[key];
  return (icon as unknown as LucideIcon) ?? Icons.Circle;
}
